var render, staticRenderFns
import script from "./StaticImageSlider.vue?vue&type=script&lang=js&"
export * from "./StaticImageSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('502a1fa5')) {
      api.createRecord('502a1fa5', component.options)
    } else {
      api.reload('502a1fa5', component.options)
    }
    
  }
}
component.options.__file = "tmp/tmp-2sqkLn2GvWYRX/JS/comp/StaticImageSlider.vue"
export default component.exports